import React, { useEffect } from 'react';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import FileCarousel from '../../components/laudos/FileCarousel';
import useViewFiles from '../../hooks/useViewFiles';

const EXTENSOES_ARQUIVO_PRONTUARIO = [
  '.pdf',
  '.PDF',
  '.jpg',
  '.jpeg',
  '.JPG',
  '.JPEG',
  '.png',
  '.PNG',
  '.bmp',
  '.BMP',
];

export const ACCEPT_ARQUIVO_PRONTUARIO = '.pdf,.jpg,.jpeg,.png,.bmp';

export default function ArquivosProntuarioModal({ codLaudo, onHide }) {
  const { urls, setURLs, loadingFiles, loadFiles } = useViewFiles({
    codLaudo,
    procedimento: 'prontuario',
    extensions: EXTENSOES_ARQUIVO_PRONTUARIO,
  });

  useEffect(() => {
    if (!codLaudo) return;
    loadFiles({ openModal: false });
  }, [codLaudo, loadFiles]);

  return (
    <Modal
      show={Boolean(codLaudo)}
      onHide={onHide}
      size="xl"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Arquivos do laudo {codLaudo}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {codLaudo && loadingFiles ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner
              animation="border"
              role="status"
              aria-label="Carregando arquivos"
            />
          </div>
        ) : null}
        {codLaudo && !loadingFiles && !urls.length ? (
          <Alert variant="warning" className="text-center font-italic mb-0">
            Nenhum arquivo encontrado para este laudo
          </Alert>
        ) : null}
        {codLaudo && !loadingFiles && urls.length ? (
          <FileCarousel urls={urls} setURLs={setURLs} />
        ) : null}
      </Modal.Body>
    </Modal>
  );
}
